import { TEXT_BADGE } from "../../../style";

export default function FieldNote({ text }) {
    if (!text) return null;
    return <small className={`block mt-1 text-color-secondary ${TEXT_BADGE}`}>{text}</small>;
}
